import type { Project, Skill } from '../api';

/** The selection key of a skill, as conversations store it. */
export function skillSelectionKey(skill: Pick<Skill, 'teamId' | 'slug'>): string {
  return `${skill.teamId}/${skill.slug}`;
}

/**
 * The project's skills this user may use, to switch on in a new conversation of the project.
 * A skill of a shared project that the user may not use is left out, never forced on.
 */
export function projectSkills(
  project: Pick<Project, 'skillSlugs'> | undefined,
  available: Skill[] | undefined,
): Skill[] {
  const wanted = new Set(project?.skillSlugs ?? []);
  if (wanted.size === 0) return [];
  return (available ?? []).filter(
    (skill) => wanted.has(skillSelectionKey(skill)) || wanted.has(skill.slug),
  );
}
